// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__h4Oiu","paramInput":"JobSimulator_paramInput__3WTe8","input":"JobSimulator_input__kIENa"};